export const PORTAL_SUSPENDED = 'PORTAL_SUSPENDED';
export const USER_WRITE_PERMISSION = 'USER_WRITE_PERMISSION';